import { Language } from '../../constants';
export const COOKIE_WIDGET_TRANSLATIONS_KEYS = {
  accessibleCloseButtonLabel: 'component.CookieWidget.accessibleLabelCloseButton',
  defaultAcceptButtonLabel: 'component.CookieWidget.defaultAcceptButtonLabel'
};
export const COOKIE_WIDGET_TRANSLATIONS = {
  [Language.CS]: {
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.accessibleCloseButtonLabel]: 'Zavřít',
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.defaultAcceptButtonLabel]: 'Dobře, přijímám'
  },
  [Language.EN]: {
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.accessibleCloseButtonLabel]: 'Close',
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.defaultAcceptButtonLabel]: 'OK, I accept'
  },
  [Language.PL]: {
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.accessibleCloseButtonLabel]: 'Zamknij',
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.defaultAcceptButtonLabel]: 'OK, akceptuję'
  },
  [Language.SK]: {
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.accessibleCloseButtonLabel]: 'Zavrieť',
    [COOKIE_WIDGET_TRANSLATIONS_KEYS.defaultAcceptButtonLabel]: 'OK, prijímam'
  }
};